import type { ISmsTemplate } from 'infrastructure/interfaces';

export const smsTemplates: ISmsTemplate[] = [
  {
    id: '1',
    type: 'message',
    topic: 'English: General Reminder',
    text: 'Reminder to take your reading today and every day. Message me here if you need assistance. Have a great day!',
  },
  {
    id: '2',
    type: 'message',
    topic: 'English: No Readings in 2 days or 3 days',
    text: "Its been a few days since your last reading. Could you please take a reading soon so we know you're well. Thanks!",
  },
  {
    id: '3',
    type: 'message',
    topic: 'English: No Readings in 4 or more days',
    text: "Your doctor has not received a reading in many days, they've asked us to remind you to take your daily reading.",
  },
  {
    id: '4',
    type: 'message',
    topic: 'English: Bingo',
    text: 'Taking your daily reading will improve your health and wellness, and increases your chances of winning Bingo!',
  },
  {
    id: '5',
    type: 'message',
    topic: 'Mensaje: General Reminder',
    text: 'le suplico no olvide tomar sus lecturas diariamente. Envieme un mensaje si requiere asistencia. Tenga un lindo dia',
  },
  {
    id: '6',
    type: 'message',
    topic: 'Mensaje: No Readings in 2 days or 3 days',
    text: 'Han pasado algunos dias desde su ultima lectura. Seria usted tan amable de tomarse una a la brevedad posible para estar seguros que esta usted bien :)',
  },
  {
    id: '7',
    type: 'message',
    topic: 'Mensaje: No Readings in 4 or more days',
    text: 'Su doctor no ha recibido sus lecturas en varios dias, nos han pedido que le recordemos que no olvide hacerlo diariamente :)',
  },
  {
    id: '8',
    type: 'message',
    topic: 'Mensaje: Bingo',
    text: 'Recuerde que tomar sus lecturas mejorara su salud y bienestar, y esto aumenta tambien su oportunidad de ganar en Bingo!',
  },
];
